/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Cat(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M221.4126,36.25659a16.40365,16.40365,0,0,0-17.04737,4.06372L187.46,57.22656a111.22891,111.22891,0,0,0-118.91894,0L51.63379,40.31982a16.40325,16.40325,0,0,0-17.04688-4.063A15.9582,15.9582,0,0,0,24,51.31348V136c0,47.50391,37.57251,87.05957,86.72656,94.67578A8.01964,8.01964,0,0,0,120,222.77075V195.314l-13.42163-13.42163a8.21993,8.21993,0,0,1-.40625-11.37329,8.00123,8.00123,0,0,1,11.48511-.17578L128,180.68652l10.34277-10.34326a8.00123,8.00123,0,0,1,11.48511.17578,8.21993,8.21993,0,0,1-.40625,11.37329L136,195.314v27.45679a8.01964,8.01964,0,0,0,9.27344,7.905C194.42749,223.05957,232,183.50391,232,136V51.31348A15.95841,15.95841,0,0,0,221.4126,36.25659ZM84,152a12,12,0,1,1,12-12A12,12,0,0,1,84,152Zm20-64a8,8,0,0,1-16,0V69.00879a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Zm16,0V69.00879a8,8,0,0,1,16,0V88a8,8,0,0,1-16,0Zm20,64a12,12,0,1,1,12-12A12,12,0,0,1,172,152Z" />
    </Svg>
  );
}

export default Cat;
